// external
import React, { FC, useEffect } from 'react';
import COEHeaderComponent from '../../components/coe-header/coe-header.component';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSnackbarHelper from '../../hooks/snackbar.hook';
import PaymentsService from '../../services/payments.service';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import useService from '../../hooks/service.hook';

const CreateTeamPaymentConfirmationPage: FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [teamId, setTeamId] = React.useState('');
  const paymentsService = useService(PaymentsService);
  const { showSnackbar } = useSnackbarHelper();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paymentIntentId = searchParams.get('payment_intent');

    if (!paymentIntentId) {
      showSnackbar('Error while processing payment please try again later', 'error');
      navigate('/teams');
    } else {
      paymentsService
        .getPaymentStatus(paymentIntentId)
        .then((res) => {
          setTeamId(res.data.data.teamId);
          setLoading(false);
        })
        .catch(() => {
          showSnackbar('There was an error verifying your payment please reach out to support', 'error');
          navigate('/teams');
        });
    }
  }, []);

  return (
    <div className={window.localStorage.getItem('sidedrawer') ? 'page-full' : 'page'} id="page">
      <COEHeaderComponent title="Create New Team Confirmation" />
      {loading ? (
        <div
          style={{
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h3" marginBottom={2}>
            Fetching payment information...
          </Typography>
          <CircularProgress style={{ alignSelf: 'center', width: 100, height: 100 }} />
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h3" marginBottom={2}>
            Your team has been successfully purchased. Click below to view and manage your team
          </Typography>
          <CheckCircleOutlineIcon style={{ alignSelf: 'center', width: 100, height: 100 }} color="success" />
          <Button onClick={() => navigate(`/teams/${teamId}/roster`)}>View Team</Button>
        </div>
      )}
    </div>
  );
};

export default CreateTeamPaymentConfirmationPage;
